import { CommonUtils } from '@helpers/commonUtils';
import { StringUtils } from '@helpers/stringUtils';
import { DATA_STORE_KEYS, DataStore } from '@providers/dataStore';

export const userManager = {
    // Get user data from local storage
    getUserData: () => {
        const user = DataStore.getItem(DATA_STORE_KEYS.USER_EMPLOYEE);
        if (user && !StringUtils.isEmpty(user)) {
            return CommonUtils.jsonSafeParse(user);
        }
        return null;
    },

    getUserDataLocal: () => {
        const user = DataStore.getItem(DATA_STORE_KEYS.USER_DATA);
        if (user && !StringUtils.isEmpty(user)) {
            return CommonUtils.jsonSafeParse(user);
        }
        return null;
    },

    getGUserData: () => {
        const user = DataStore.getItem(DATA_STORE_KEYS.USER);
        if (user && !StringUtils.isEmpty(user)) {
            return CommonUtils.jsonSafeParse(user);
        }
        return null;
    },
};
